import { merge, Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { SearchClient } from 'algoliasearch'
import { InstantSearchOptions as InstantSearchConfig } from 'instantsearch.js/es/types'

import { Component, Inject, OnInit } from '@angular/core'

import { ALGOLIA_SEARCH_CLIENT } from '@app-domains/algolia/algolia.module'
import { GeolocationService, Pages, SeoService } from '@app-services'
import { PlainSearchParameters } from 'algoliasearch-helper'

@Component({
    selector: 'app-dealers',
    templateUrl: './dealers.component.html',
})
export class DealersComponent implements OnInit {

    public config: InstantSearchConfig = {
        indexName: 'dealers',
        searchClient: this.searchClient,
    }

    public instantSearchConfig: InstantSearchConfig

    public mainIndex: string
    public searchParameters$: Observable<PlainSearchParameters>

    constructor(
        @Inject(ALGOLIA_SEARCH_CLIENT)
        private readonly searchClient: SearchClient,
        private geolocation: GeolocationService,
        private seo: SeoService,
    ) {
    }

    public ngOnInit(): void {
        this.mainIndex = 'dealers'
        this.instantSearchConfig = {
            indexName: 'dealers',
            searchClient: this.searchClient,
        }

        this.searchParameters$ = merge(
            of(undefined),
            this.geolocation.location$,
        ).pipe(
            map(location => {
                const searchParametersConfig = {
                    hitsPerPage: 1000,
                    aroundLatLngViaIP: false,
                }

                if (! location) {
                    return searchParametersConfig
                }

                const { latitude, longitude } = location.coords
                const delta = 0.1 // roughly ~11km in latitude, varies for longitude by latitude

                const insideBoundingBox = [
                    latitude - delta,
                    longitude - delta,
                    latitude + delta,
                    longitude + delta,
                ].join(', ')

                return {
                    ...searchParametersConfig,
                    aroundLatLng: `${latitude}, ${longitude}`,
                    insideBoundingBox,
                }
            }),
        )

        this.seo.setSeoDataPage(Pages.Dealers)
    }
}
